export const getLanguages = (languageFields) => {
  let languages =
    languageFields?.map((language: any) => ({
      [language?.attributes?.["sow-language"]]: "",
    })) || [];

  let objOfLanguages = Object.assign({}, ...languages);
  return objOfLanguages;
};
